(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-bs-track]');
    if (!track) return;
    var section = root.closest('section');
    var navHost = section ? section.querySelector('[data-bs-nav]') : null;
    var prev = (navHost || root).querySelector('[data-bs-prev]');
    var next = (navHost || root).querySelector('[data-bs-next]');
    var step = function () {
      var slide = track.querySelector('.ss-bs-carousel__slide');
      return slide ? slide.offsetWidth + 16 : 280;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ss-reveal').forEach(function (el) { el.classList.add('is-visible'); });
      document.querySelectorAll('.disc-reveal, .disc-reveal-stagger').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('disc-reveal') || entry.target.classList.contains('disc-reveal-stagger')) {
            entry.target.classList.add('is-revealed');
          } else {
            entry.target.classList.add('is-visible');
          }
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.ss-reveal').forEach(function (el) { io.observe(el); });
    document.querySelectorAll('.disc-reveal, .disc-reveal-stagger').forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('[data-ss-faq]').forEach(function (root) {
      var items = root.querySelectorAll('[data-ss-faq-item]');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-ss-faq-trigger]');
        var panel = item.querySelector('[data-ss-faq-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var p = other.querySelector('[data-ss-faq-panel]');
            var t = other.querySelector('[data-ss-faq-trigger]');
            if (p) p.hidden = true;
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            panel.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bs-carousel]').forEach(initCarousel);
    initReveal();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
